module.exports = __webpack_public_path__ + "img/administrativo.3a1807e2.png";